module.exports = __webpack_public_path__ + "img/2.0e8d0657.jpg";